export const getStarsRating = (providerHealthGradeRating: number) => {
  let stars = '';
  const roundedRating = Math.round(providerHealthGradeRating);
  const count = Array.from([1, 2, 3, 4, 5]);
  for (let i = 0; i < count.length; i++) {
    if (count[i] <= roundedRating) {
      stars += '★';
    } else {
      stars += '☆';
    }
  }
  return stars;
};
